<template>
  <div ref="dialog" class="custom-dialog" v-if="value" :style="{
    left: $vuetify.application.left+'px',
    'overflow-y': showPopUp || noPadding ? 'hidden' : 'scroll'
  }">
    <div class="custom-dialog-container" >
      <div :class="['custom-dialog-closer', noCerrar || noCerrarInterno ? 'noCerrarCursor' : '' ]" @click="mostrarPopUp()"></div>
        <v-container :style="noPadding ? 'padding:0px;margin:0px;max-width:100%;':''">
          <slot></slot>
          <v-fade-transition>
            <PopUpSeguro
              v-if="showPopUp"
              @aceptar="aceptar"
              :titulo="titulo"
              :pregunta="pregunta"
              :consecuencia="consecuencia"
              :alerta="alerta"
              :descartar="descartar"
              :cancelar="cancelar"
            />
          </v-fade-transition>
        </v-container>
    </div>
  </div>
</template>
<script>
  import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
  import PopUpSeguro from './PopUpSeguro'
  export default {
    props: {
      value: Boolean,
      cambiado: {
        type: Boolean,
        default: false
      },
      titulo: {
        type: String,
        default () {
          return this.$t('general.customDialog.titulo')
        }
      },
      pregunta: {
        type: String,
        default () {
          return this.$t('general.customDialog.pregunta')
        }
      },
      consecuencia: {
        type: String,
        default: ''
      },
      alerta: {
        type: String,
        default () {
          return this.$t('general.customDialog.alerta')
        }
      },
      descartar: {
        type: String,
        default () {
          return this.$t('general.customDialog.descartar')
        }
      },
      cancelar: {
        type: String,
        default () {
          return this.$t('general.customDialog.cancelar')
        }
      },
      noCerrar: Boolean,
      subPopUp: {
        type: Boolean,
        default: false
      },
      noPadding: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showPopUp: false,
        noCerrarInterno: false
      }
    },
    components: {
      PopUpSeguro
    },
    mounted () {
      if (this.value) {
        disableBodyScroll(this.$refs.dialog, {reserveScrollBarGap: true})
      }
    },
    watch: {
      value (newVal) {
        if (newVal) {
          disableBodyScroll(this.$refs.dialog, {reserveScrollBarGap: true})
        } else {
          if (!this.subPopUp) { // Si no soy subpopup devolver el scroll principal
            clearAllBodyScrollLocks()
          }
        }
      }
    },
    methods: {
      hide () {
        this.showPopUp = false
        if (!this.subPopUp) { // Si no soy subpopup devolver el scroll principal
          clearAllBodyScrollLocks()
        }
        this.$emit('input', false)
      },
      mostrarPopUp () {
        if (!this.noCerrar && !this.noCerrarInterno) {
          if (!this.cambiado) {
            this.hide()
          } else {
            this.showPopUp = true
          }
        }
      },
      aceptar (aceptado) {
        if (aceptado) {
          this.showPopUp = false
          this.$emit('aceptar')
        } else {
          this.showPopUp = false
        }
      }
    },
    beforeDestroy () {
      this.hide()
    }
  }
</script>

<style lang="stylus" scoped>
  .custom-dialog
    position fixed
    top 0
    bottom 0
    right 0
    left 0
    z-index 6
    overflow-y scroll
    transition-property: transform, width, -webkit-transform
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  .custom-dialog-container
    position relative
    min-height 100%
    width 100%
    display flex
    align-content center
  .custom-dialog-closer
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    min-height 100vh
    background-color rgba(0,0,0,.8)
    &:hover:not(.noCerrarCursor)
      cursor pointer

</style>






// WEBPACK FOOTER //
// src/components/generic/CustomDialog.vue